import AppRecord from './AppRecord.js'
import APP from 'src/main.js'

class ControlledByMixin extends AppRecord {
  resetMomerizedComputed(){
    this._controlled_days_ago = null
    this._completed_days_ago = null
  }
  get person_controller(){
    return this.constructor.employeeStore.users.find(usr => usr.id === this.controlled_by)
  }
  get person_controller_name(){
    if(this.person_controller){
      return this.person_controller.name
    } else {
      return null
    }
  }
  controlled(){
    return this.controlled_by ? true : false
  }
  get controlled_days_ago(){
    if(this.controlled_at){
      // return 1
      if(this._controlled_days_ago){return this._controlled_days_ago}
      let now = (new Date).getTime()
      let seen = Date.parse(this.controlled_at)
      return this._controlled_days_ago = Math.round((now-seen)/1000/60/60/24)
    } else {
      return Infinity
    }
  }
  get person_completer(){
    return this.constructor.employeeStore.users.find(usr => usr.id === this.completed_by)
  }
  get person_completer_name(){
    if(this.person_completer){
      return this.person_completer.name
    } else {
      return null
    }
  }
  completed(){
    return this.completed_by ? true : false
  }
  get completed_days_ago(){
    if(this.completed_at){
      // return 1
      if(this._completed_days_ago){return this._completed_days_ago}
      let now = (new Date).getTime()
      let seen = Date.parse(this.completed_at)
      return this._completed_days_ago = Math.round((now-seen)/1000/60/60/24)
    } else {
      return Infinity
    }
  }
}

export default ControlledByMixin
